import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useDraftOrderStaff = (order, person, enabled) => {
  return useQuery({
    queryKey: ["draftOrderStaff", order, person],
    enabled: enabled,
    queryFn: async () =>
      callApi({
        path: "draftorderstaffcard",
        command: "get",
        data: JSON.stringify({
          data: { filter: { orderNo: order, staffLineNo: person } },
        }),
      }),
  });
};
